import { render, staticRenderFns } from "./CardLabelsFilter.vue?vue&type=template&id=0dcfaa91&"
import script from "./CardLabelsFilter.vue?vue&type=script&lang=ts&"
export * from "./CardLabelsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports